import {
  isSystemRoleName,
  SystemRoleName,
} from '@evimo/types/enums/system-role-name';

export const DEFAULT_LANDING_PATH = '/home';

export const ROLE_REDIRECT: Record<SystemRoleName, string> = {
  [SystemRoleName.SUPER_ADMIN]: DEFAULT_LANDING_PATH,
  [SystemRoleName.ORGANIZATION_MANAGER]: DEFAULT_LANDING_PATH,
  [SystemRoleName.SUPERVISOR]: DEFAULT_LANDING_PATH,
  [SystemRoleName.FIELD_TECHNICIAN]: DEFAULT_LANDING_PATH,
  [SystemRoleName.SYSTEM]: DEFAULT_LANDING_PATH,
};

export function getRoleRedirectPath(
  roleName: string | null | undefined,
): string {
  if (!roleName || !isSystemRoleName(roleName)) {
    return DEFAULT_LANDING_PATH;
  }

  return ROLE_REDIRECT[roleName];
}
